import {RECENT_SEARCHES_KEY, RECENT_SEARCHES_MAX} from './constants.js';

function getData(){
	return JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY));
}

function setData(value){
	localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(value));
}

function clearData(){
	localStorage.removeItem(RECENT_SEARCHES_KEY);
}

function toLower(value){
	return value.toLowerCase();
}

var data = null;

export function getAll(){
	return data = data || getData() || [];
}

export function addValue(value){
	if (value.trim().length === 0) return;

	var values = getAll();

	if (values.map(toLower).includes(toLower(value))) return;

	if (values.unshift(value) > RECENT_SEARCHES_MAX){
		values.pop();
	}

	setData(values);
	data = values;
}

export function removeValue(value){
	var values = getAll().filter(s => s !== value);
	setData(values);
	data = values;
}

export function removeAll(){
	clearData();
	data = [];
}